import Block, { BlockProps } from "./block";

export type ArticleBlockProps = BlockProps & {};

export function ArticleBlock(props: BlockProps) {
  return (
    <Block {...props}>
      <div className="mx-auto max-w-prose">{props.children}</div>
    </Block>
  );
}

export default ArticleBlock;
